import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import LogoutPage from "./Logout";
import ChangePassword from "../../Modals/ChangePassword";
import avatar from "../../../images/sheLogo.png";
import { KeyRound } from "lucide-react";
import { NavMenuToggle } from "./NavHader";
import { getUserData } from "../../../services/UserServices/UserService";
import { setUserProfile } from "../../../store/reducers/RoleSlice";

const Header = ({ onNote }) => {
  const [changePassword, setChangePassword] = useState(false);
  const dispatch = useDispatch();
  const roleData = useSelector((state) => state.role.roles);

  const getUser = async () => {
    try {
      const res = await getUserData();
      dispatch(setUserProfile(res.data.data));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className="navv qx-header">
      <ChangePassword
        password={changePassword}
        onHide={() => setChangePassword(false)}
      />

      <div className="header-content qx-header-content w-100 px-3">
        <nav className="navbar navbar-expand p-0 w-100">
          <div className="collapse navbar-collapse justify-content-between w-100">
            <div className="header-left qx-header-left d-flex align-items-center gap-3">
              <button
                type="button"
                className="qx-sidebar-toggle"
                onClick={NavMenuToggle}
                aria-label="Toggle Sidebar"
              >
                <svg
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1.5ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>

            <ul className="navbar-nav header-right prof m-0">
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="i-false c-pointer nav-link d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm"
                  style={{ backgroundColor: "#E5484D", border: "none" }}
                  to=""
                  role="button"
                >
                  <div className="header-info me-2 text-end">
                    <span className="d-block fw-semibold text-white fs-14" style={{ color: "#ffffff" }}>
                      {roleData ? roleData?.name : "Admin"}
                    </span>
                    <small className="fs-12 d-block" style={{ color: "rgba(255, 255, 255, 0.85)" }}>
                      Super Admin
                    </small>
                  </div>
                  <div className="profile-img-wrapper p-1 rounded-circle bg-white border">
                    <img
                      src={avatar}
                      width={28}
                      height={28}
                      style={{ objectFit: "contain" }}
                      alt="Avatar"
                    />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="end"
                  className="dropdown-menu dropdown-menu-right shadow-lg border-0 rounded-12 mt-2 p-2"
                  style={{ zIndex: 9999, backgroundColor: "#ffffff" }}
                >
                  <div className="px-3 py-2 border-bottom mb-1">
                    <p className="mb-0 font-weight-bold text-dark fs-14">
                      {roleData ? roleData?.name : "Administrator"}
                    </p>
                    <small className="text-muted">She Rents Admin</small>
                  </div>
                  <Link
                    to="#"
                    className="dropdown-item ai-icon d-flex align-items-center py-2 rounded-8"
                    onClick={() => setChangePassword(true)}
                  >
                    <KeyRound
                      size={16}
                      style={{ color: "#E5484D", marginRight: 10 }}
                    />
                    <span className="ml-2">Change Password</span>
                  </Link>
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
